import React, { useEffect } from 'react'
import { MapContainer, TileLayer, Marker, Popup, Tooltip, useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

const countryCoordinates = {
    IN: [20.5937, 78.9629],
    US: [37.0902, -95.7129],
    UK: [55.3781, -3.436],
    FR: [46.6034, 1.8883],
    DE: [51.1657, 10.4515],
    CN: [35.8617, 104.1954],
    JP: [36.2048, 138.2529],
    RU: [61.524, 105.3188],
    BR: [-14.235, -51.9253],
    CA: [56.1304, -106.3468],
    AU: [-25.2744, 133.7751],
    IT: [41.8719, 12.5674],
    ES: [40.4637, -3.7492],
    MX: [23.6345, -102.5528],
    ZA: [-30.5595, 22.9375],
    AR: [-38.4161, -63.6167], // Argentina
    EG: [26.8206, 30.8025], // Egypt
    NG: [9.082, 8.6753], // Nigeria
    SA: [23.8859, 45.0792], // Saudi Arabia
    KR: [35.9078, 127.7669], // South Korea
    TR: [38.9637, 35.2433], // Turkey
    ID: [-0.7893, 113.9213], // Indonesia
    PK: [30.3753, 69.3451], // Pakistan
    BD: [23.685, 90.3563], // Bangladesh
    VN: [14.0583, 108.2772], // Vietnam
    PH: [12.8797, 121.774], // Philippines
    TH: [15.870, 100.9925], // Thailand
    MY: [4.2105, 101.9758], // Malaysia
    SG: [1.3521, 103.8198], // Singapore
    NZ: [-40.9006, 174.886], // New Zealand
    KE: [-1.2921, 36.8219], // Kenya
    ET: [9.145, 40.4897], // Ethiopia
    DZ: [28.0339, 1.6596], // Algeria
    MA: [31.7917, -7.0926], // Morocco
    CO: [4.5709, -74.2973], // Colombia
    VE: [6.4238, -66.5897], // Venezuela
    CL: [-35.6751, -71.543], // Chile
    PE: [-9.19, -75.0152], // Peru
    UA: [48.3794, 31.1656], // Ukraine
    PL: [51.9194, 19.1451], // Poland
    NL: [52.1326, 5.2913], // Netherlands
    BE: [50.5039, 4.4699], // Belgium
    SE: [60.1282, 18.6435], // Sweden
    NO: [60.472, 8.4689], // Norway
    FI: [61.9241, 25.7482], // Finland
    DK: [56.2639, 9.5018], // Denmark
    CH: [46.8182, 8.2275], // Switzerland
    AT: [47.5162, 14.5501], // Austria
    GR: [39.0742, 21.8243], // Greece
    PT: [39.3999, -8.2245], // Portugal
    IE: [53.1424, -7.6921], // Ireland
    IL: [31.0461, 34.8516], // Israel
    IR: [32.4279, 53.688], // Iran
    IQ: [33.2232, 43.6793], // Iraq
    SY: [34.8021, 38.9968], // Syria
    JO: [30.5852, 36.2384], // Jordan
    LB: [33.8547, 35.8623], // Lebanon
    QA: [25.3548, 51.1839], // Qatar
    AE: [23.4241, 53.8478], // United Arab Emirates
    KW: [29.3117, 47.4818], // Kuwait
    OM: [21.4735, 55.9754], // Oman
    BH: [25.9304, 50.6378], // Bahrain
    YE: [15.5527, 48.5164], // Yemen
    AF: [33.9391, 67.71], // Afghanistan
    KZ: [48.0196, 66.9237], // Kazakhstan
    UZ: [41.3775, 64.5853], // Uzbekistan
    TM: [38.9697, 59.5563], // Turkmenistan
    KG: [41.2044, 74.7661], // Kyrgyzstan
    TJ: [38.861, 71.2761], // Tajikistan
    MN: [46.8625, 103.8467], // Mongolia
    NP: [28.3949, 84.124], // Nepal
    LK: [7.8731, 80.7718], // Sri Lanka
    MM: [21.9162, 95.956], // Myanmar
    KH: [12.5657, 104.991], // Cambodia
    LA: [19.8563, 102.495], // Laos
    BD: [23.685, 90.3563], // Bangladesh
    MV: [3.2028, 73.2207], // Maldives
    BT: [27.5142, 90.4336], // Bhutan
    FJ: [-17.7134, 178.065], // Fiji
    PG: [-6.314993, 143.95555], // Papua New Guinea
    SB: [-9.6457, 160.156], // Solomon Islands
    VU: [-15.3767, 166.9592], // Vanuatu
    WS: [-13.759, -172.1046], // Samoa
    TO: [-21.1789, -175.1982], // Tonga
    TV: [-7.1095, 177.6493], // Tuvalu
    KI: [-3.3704, -168.734], // Kiribati
    NR: [-0.5228, 166.9315], // Nauru
    MH: [7.1315, 171.1845], // Marshall Islands
    FM: [7.4256, 150.5508], // Micronesia
    PW: [7.5149, 134.5825], // Palau
    TL: [-8.8742, 125.7275], // Timor-Leste
    BN: [4.5353, 114.7277], // Brunei
    MO: [22.1987, 113.5439], // Macau
    HK: [22.3193, 114.1694], // Hong Kong
    TW: [23.6978, 120.9605], // Taiwan
    KP: [40.3399, 127.5101], // North Korea
    BT: [27.5142, 90.4336], // Bhutan
    MV: [3.2028, 73.2207], // Maldives
    NP: [28.3949, 84.124], // Nepal
    LK: [7.8731, 80.7718], // Sri Lanka
    MM: [21.9162, 95.956], // Myanmar
    KH: [12.5657, 104.991], // Cambodia
    LA: [19.8563, 102.495], // Laos
    BD: [23.685, 90.3563], // Bangladesh
    MV: [3.2028, 73.2207], // Maldives
    BT: [27.5142, 90.4336], // Bhutan
    FJ: [-17.7134, 178.065], // Fiji
    PG: [-6.314993, 143.95555], // Papua New Guinea
    SB: [-9.6457, 160.156], // Solomon Islands
    VU: [-15.3767, 166.9592], // Vanuatu
    WS: [-13.759, -172.1046], // Samoa
    TO: [-21.1789, -175.1982], // Tonga
    TV: [-7.1095, 177.6493], // Tuvalu
    KI: [-3.3704, -168.734], // Kiribati
    NR: [-0.5228, 166.9315], // Nauru
    MH: [7.1315, 171.1845], // Marshall Islands
    FM: [7.4256, 150.5508], // Micronesia
    PW: [7.5149, 134.5825], // Palau
    TL: [-8.8742, 125.7275], // Timor-Leste
    BN: [4.5353, 114.7277], // Brunei
    MO: [22.1987, 113.5439], // Macau
    HK: [22.3193, 114.1694], // Hong Kong
    TW: [23.6978, 120.9605], // Taiwan
    KP: [40.3399, 127.5101], // North Korea
};

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
})

const FitBounds = ({ locationDetails }) => {
    const map = useMap()
    useEffect(() => {
        if (locationDetails.length > 0) {
            const bounds = locationDetails.map(
                (loc) => countryCoordinates[loc.CountryCode] || [0,0]
            )
            map.fitBounds(bounds)
        }
    }, [locationDetails, map])

    return null
}

const MapComponent = ({ locationDetails = [] }) => {
    return (
        <MapContainer center={[20.5937, 78.9629]} zoom={3} style={{ height: '300px', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

            <FitBounds locationDetails={locationDetails} />

            {locationDetails.map(({ CountryCode, Count }) => {
                if(CountryCode !=='NA'){
                const position = countryCoordinates[CountryCode] || [0,0]
                return (
                    <Marker key={CountryCode} position={position}>
                        <Popup>
                            Country: {CountryCode} <br />
                            User Count: {Count}
                        </Popup>
                        <Tooltip>
                            Country: {CountryCode} <br />
                            User Count: {Count}
                        </Tooltip>
                    </Marker>
                )
                }
            })}
        </MapContainer>
    )
}

export default MapComponent;